<template>
  <div id="app">
    <loading></loading>
    <snackbar></snackbar>
    <Alert />
    <navbar></navbar>
    <router-view></router-view>
    <footerbar class="ep-footer"></footerbar>
  </div>
</template>

<script>
import loading from '@/components/loading';
import snackbar from '@/components/snackbar';
import Alert from '@/components/Alert';
import navbar from '@/components/navbar';
import footerbar from '@/components/footer';
import trackingServices from './plugins/posthog';

export default {
  name: 'edoc-perso',

  components: {
    loading,
    snackbar,
    navbar,
    footerbar,
    Alert,
  },

  mounted() {
    trackingServices.getPostHogInstance();
  },

};
</script>



// WEBPACK FOOTER //
// src/App.vue